export default "__VITE_PUBLIC_ASSET__6bd363e9__"